import React from 'react';
import TextEdit from '../../molecules/TextEdit';
import { formatCurrency } from './structuringUtils';

interface OperationSummaryProps {
    totalAmount: number;
    totalDocuments: number;
    totalReceivables: number;
    notes: string;
}

const OperationSummary: React.FC<OperationSummaryProps> = ({ totalAmount, totalDocuments, totalReceivables, notes }) => (
    <>
        <div className="grid grid-cols-12 gap-4 mb-6">
            <div className="col-span-4">
                <TextEdit label="Valor Total:" value={formatCurrency(totalAmount)} disabled />
            </div>
            <div className="col-span-4">
                <TextEdit label="Total de Documentos:" value={totalDocuments.toString()} disabled />
            </div>
            <div className="col-span-4">
                <TextEdit label="Total de Recebíveis:" value={totalReceivables.toString()} disabled />
            </div>
        </div>
        {notes && (
            <div className="mb-6">
                <TextEdit label="Observações:" value={notes} disabled />
            </div>
        )}
    </>
);

export default OperationSummary;
